var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CheckIcon from '@mui/icons-material/Check';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { logger, handleExport, customBodyForExcelReport, checkAuthentication,muiLoaderOptions } from '../../utils';
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

export default function HandelPOBillingReport({ PO, invoiceID, display }) {
    const [refresh, setRefresh] = React.useState(false);
    const [Report, setReport] = React.useState([]);
    const [invoice, setInvoice] = React.useState([]);
    const [billTime, setBillTime] = React.useState([]);
    const [list, setList] = React.useState([])
    const [start, setStart] = React.useState();
    const [end, setEnd] = React.useState();
    const [Discount, setDiscount] = React.useState({})
    const [overTime, setsOverTime] = React.useState([])
    const [filename, setFilename] = React.useState("")
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const timer = React.useRef(null); 

    const classes = pageStyles();

    const GetOverTime = async (sow, IsBilled, DiscountID, Date) => {
        logger("GetOverTime", `sow: ${sow} IsBilled: ${IsBilled} DiscountID: ${DiscountID} Date: ${Date}`)
        await fetch(`/api/SOW/OverTime/${sow}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setsOverTime(json))

        if (IsBilled == 1) {
            fetch(`/api/DiscountID/${DiscountID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    logger("Discount", json)
                    setDiscount(json[0])
                });
        } else {
            fetch(`/api/Discount_Active/${Date}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setDiscount(json));
        }
    };

    const getTotal = () => {
        let total = 0
        list.map((item, index) => {
            const byteArray = new Uint8Array(item.Rate.data);
            const textDecoder = new TextDecoder();
            const res = textDecoder.decode(byteArray);
            const r = parseFloat(res).toFixed(2);
            total += calculateRate(r, item.FlagType) * item.Hours
        })
        return total.toFixed(2)
    };

    const grandTotal = (Labor, Expense) => {
        let res;
        if (Expense > 0) {
            const discountedLabor = applyDiscount(parseFloat(Labor).toFixed(2));
            let tmpTotal = parseFloat(discountedLabor) + parseFloat(Expense)
            let res = parseFloat(tmpTotal).toFixed(2)
            logger(`GT with Exp`, res)
            return res;
        } else {
            const tmpTotal = applyDiscount(parseFloat(Labor).toFixed(2))
            let res = parseFloat(tmpTotal).toFixed(2)
            logger(`GT no Exp`, res)
            return res;
        }
        return res;
    }

    const applyDiscount = (price) => {
        var getPrice = Discount.Discount / 100;

        var totalValue = price - (price * getPrice)
        logger(totalValue.toFixed(2));
        return totalValue.toFixed(2);
    }

    const getReport = async () => {
        
        logger(`api/BillingInvoice/${PO}/${invoiceID}`)
        const call = await fetch(`/api/BillingInvoice/${PO}/${invoiceID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                logger(`/api/BillingInvoice/${PO}/${invoiceID}`, json)
                var format = ""
                setEnd(json[0].EndDate)
                setStart(json[0].POStart)
                GetOverTime(json[0].SOWID, json[0].IsBilled, json[0].DiscountID, json[0].EndDate)
                setFilename(`InvoiceSummary_PO#${json[0].PoNumber}.xlsx`);
                json.map((value, index) => {
                    format = `
                                ${moment.utc(value.StartDate).format('MMMM')}
                                ${moment.utc(value.StartDate).format('MM/DD/YYYY')}-${moment.utc(value.EndDate).format('MM/DD/YYYY')}
                                
                                INVOICE REQUEST_${value.PoNumber}_${moment.utc(value.StartDate).format('MMMM')}
                                
                                PO#:${value.PoNumber}
                                Name:${value.Name}

                                Discount Rate:${Discount.Discount}%
                                RAW Labor:$${getTotal()}
                                Discounted Labor:$${applyDiscount(getTotal())}
                                Expenses:$${value.TotalExpenses == null ? 0 : value.TotalExpenses}
                                Invoice Total: $${grandTotal(getTotal(), value.TotalExpenses)}
                                Sold To:${value.SoldTo}
                                Ship To:${value.ShipTo}

                                CostCenter:${value.NameCostCenter}
                                CostCenter#:${value.CostCenter}
                                Invoice Amount:${value.InvoiceAmount}

                                Owner:${value.Owner}
                                Email:${value.Email}
                                Email Group:${value.EmailGroup}`;
                })
                setReport([{"INVOICE REQUEST": format }]);
				})

        return call
    };

    const getInvoice = async () => {
        logger("getInvoice", `api/invoiceBy/${PO}`)
        try {
            const call = await fetch(`api/invoiceBy/${PO}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    logger(`api/invoiceBy/${PO}`, json);
                    var output = []
                    json.map((value, index) => {
                        output.push({
                            "InvoiceDate": value.InvoiceDate,
                            "PO": value.PO,
                            "InvoiceNumber": value.InvoiceNumber,
                            "StartDate": moment.utc(value.StartDate).format('MM/DD/YYYY'),
                            "EndDate": moment.utc(value.EndDate).format('MM/DD/YYYY'),
                            "Amount": value.Amount,
                            "ExpenseTotal": value.ExpenseTotal
                        })
                    })
                    setInvoice(output)
                })
        } catch (error) {
            console.error(`Error loading UserList`, error)
        }

        return true;
    };

    const calculateRate = (rate, flagType) => {
        if (overTime.length) {
            if (flagType === 'OT') {
                return (rate * overTime[0].OverTimeWeek).toFixed(2);
            } else if (flagType === 'WND') {
                return (rate * overTime[0].OverTimeWeekEnd).toFixed(2);
            } else if (flagType === 'HOL') {
                return (rate * overTime[0].OverTimeHoliday).toFixed(2);
            } else {
                return rate;
            }
        }
    }

    const getBillTime = async () => {
        logger("getBillTime", `/api/Reports/time_entry/${moment.utc(start).format('YYYY-MM-DD')}/${moment.utc(end).format('YYYY-MM-DD')}/${PO}/1`)
        const call = await fetch(`/api/Reports/time_entry/${moment.utc(start).format('YYYY-MM-DD')}/${moment.utc(end).format('YYYY-MM-DD')}/${PO}/1`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                logger(`/api/Reports/time_entry/${moment.utc(start).format('YYYY-MM-DD')}/${moment.utc(end).format('YYYY-MM-DD')}/${PO}/1`, json);
                var output = []
                json.map((value, index) => {
                    var eachRow = value

                    var payRate = eachRow.Rate;
                    const byteArray = new Uint8Array(payRate.data);
                    const textDecoder = new TextDecoder();
                    const res = textDecoder.decode(byteArray);
                    const rate = parseFloat(res).toFixed(2);

                    eachRow.Rate = calculateRate(rate, eachRow.FlagType);
                    
                    delete eachRow['ID']
                    delete eachRow['VerifyStatus']
                    delete eachRow['overTimeWarning']
                    delete eachRow['UserID']
                    delete eachRow['IsBillable']
                    delete eachRow['Lab_ID']
                    delete eachRow['ProjectID']
                    delete eachRow['timeEntryID']
                    if (!display) {
                        delete eachRow['Name']
                    }
                    eachRow.DayOf = moment.utc(eachRow.DayOf).format('MM/DD/YYYY')
                    eachRow.WeekOf = moment.utc(eachRow.WeekOf).format('MM/DD/YYYY')
                    output.push(eachRow)
                })
                setBillTime(output)
            })

        return call
    };
    
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const generateReport = () => {
        logger('generateReport')
        logger("Report", Report)
        logger("invoice", invoice)
        logger("billTime", billTime)
        function populateWorksheet(worksheet, rows, headers) {
            if (headers && headers.length) {
                const headerRow = worksheet.addRow(headers);
                headerRow.font = { bold: true };
            } else {
                console.error("No headers found.");
            }

            if (rows && rows.length) {
                rows.forEach((row, rowIndex) => {
                    const rowData = Array.isArray(row) ? row : Object.values(row);
                    worksheet.addRow(rowData);

                    // Ensure columns auto-adjust width
                    worksheet.columns.forEach((col) => {
                        if (col && col.values) {
                            const maxColumnWidth = col.values.reduce((maxWidth, value) => {
                                if (value && value.toString().length > maxWidth) {
                                    return value.toString().length;
                                }
                                return maxWidth;
                            }, 10);
                            col.width = Math.min(maxColumnWidth + 2, 40); // Set a max width
                        }
                    });
                });
            } else {
                console.error("No rows data found.");
            }
        }
        // Custom buildHead and buildBody functions
       

        const rowsForTab1 = Report;
        const rowsForTab2 = invoice;
        const rowsForTab3 = billTime;

        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('Report');
        const worksheet2 = workbook.addWorksheet('Invoice');
        const worksheet3 = workbook.addWorksheet('BillTime');

        const headers1 = Object.keys(Report[0]);
        const headers2 = Object.keys(invoice[0]); 
        const headers3 = Object.keys(billTime[0]);
        
        populateWorksheet(worksheet1, rowsForTab1, headers1);
        populateWorksheet(worksheet2, rowsForTab2, headers2);
        populateWorksheet(worksheet3, rowsForTab3, headers3);

        /*const customBuildHead = () => {
            var newColumns = Object.keys(Report[0]);
            return newColumns;
        }*/
        //const headers = customBuildHead();

        //const rows = customBuildBody();
        var add_date = true;
        const currentDate = moment.utc().format("yyyy-MM-DD");
        //handleExport({rows:rows, headers:headers, filename: 'LPCheck.xlsx'})
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
                : (filename || 'datatable.xlsx');
            a.click();
        }).catch(error => {
            console.error("Error generating Excel file: ", error);
        });
        return false;
    };

    async function processData() {
        try {
            const processReport = await getReport()
            const processInvoice = await getInvoice() 
            if (start) {
                logger("dates loop", { "Start": start, "End": end })
                const processgetBillTime = await getBillTime()
            }
        } catch (error) {
            console.error(`Error processing`, error)
        }
        if (billTime.length > 0 && start != undefined) {
            setRefresh(false)
                generateReport()
        } else {
            timer.current = setTimeout(() => {
                setRefresh(true)
            }, 1000);

        }

    }

    React.useEffect(() => {
        if (refresh) {
            logger("refresh")
            fetch(`/api/InvoiceBreakdown/${invoiceID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    logger("get invoices", json);
                    setList(json);
                })
            processData()
            setRefresh(false);
        }

    })

    return (
        <div className={classes.root}>
            <Button autoFocus color="inherit" onClick={handleClickOpen}>
                Download
            </Button>
        </div>
    );
}

 